"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OldMonthlyPayWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@athena-portal/journey-services");
var journey_model_1 = require("@athena-portal/journey-model");
var commonFunctions_1 = require("../../commonFunctions");
var OldMonthlyPayWidget = /** @class */ (function (_super) {
    __extends(OldMonthlyPayWidget, _super);
    function OldMonthlyPayWidget(props) {
        return _super.call(this, props) || this;
    }
    OldMonthlyPayWidget.prototype.render = function () {
        var amountToRefundField = this.getSetting("amountToRefundField");
        var newPriceField = this.getSetting("newPriceField");
        if (!amountToRefundField) {
            throw Error("".concat(this.props.question.type, " widget is missing 'amountToRefundField' setting"));
        }
        else if (!newPriceField) {
            throw Error("".concat(this.props.question.type, " widget is missing 'newPriceField' setting"));
        }
        var amountToRefund = journey_services_1.ObjectManipulator.fetchFieldValue(amountToRefundField, this.props.interaction);
        var newPrice = journey_services_1.ObjectManipulator.fetchFieldValue(newPriceField, this.props.interaction);
        var oldPrice = this.props.interaction.uistate.previousMonthlyPayment;
        var isPositiveMonthlyPayment = this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment > 0;
        if (this.props.interaction.factors.premiumType === "monthly" && isPositiveMonthlyPayment) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["This amount will be deduced from the outstanding balance and spread evenly over your remaining monthly payments. You currently pay ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: (0, commonFunctions_1.getAmountWithDecimalDigits)(oldPrice) }), " / month."] }), (0, jsx_runtime_1.jsxs)("p", { children: ["The refund of ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: (0, commonFunctions_1.getAmountWithDecimalDigits)(amountToRefund) }), " has reduced your remaining monthly payments to ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: (0, commonFunctions_1.getAmountWithDecimalDigits)(newPrice) }), " / month."] })] }));
        }
        else {
            return ((0, jsx_runtime_1.jsxs)("p", { className: "text-center mb-0", children: ["You will receive ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: (0, commonFunctions_1.getAmountWithDecimalDigits)(amountToRefund) }), " pro rata refund for changing address on your car policy. The refund excludes the cost of your cover prior to the address changing date."] }));
        }
    };
    OldMonthlyPayWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "amountToRefund", type: journey_model_1.TypeDescriptions.String },
            { name: "newPrice", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], OldMonthlyPayWidget);
    return OldMonthlyPayWidget;
}(plugin_journey_1.WidgetBase));
exports.OldMonthlyPayWidget = OldMonthlyPayWidget;
//# sourceMappingURL=OldMonthlyPayWidget.js.map